define( 'form-validation',[ 'jquery', 'parsley' ],

	function ( $ ) {

		'use strict';

		var pasteQueue = [],
				pasteRunner;

		// large number modulus function
		function modulo (divident, divisor) {
			var cDivident = '';
			var cRest = '';

			for (var i in divident ) {
				var cChar = divident[i];
				var cOperator = cRest + '' + cDivident + '' + cChar;

				if ( cOperator < parseInt(divisor) ) {
					cDivident += '' + cChar;
				} else {
					cRest = cOperator % divisor;
					if ( cRest == 0 ) {
						cRest = '';
					}
					cDivident = '';
				}
			}

			cRest += '' + cDivident;
			if (cRest == '') {
				cRest = 0;
			}
			return cRest;
		}

		/**
		 * Constrain the following fields to numbers
		 *
		 * business partner number
		 * mobile
		 * landline (phone, fax)
		 * verification code
		 * account number
		 * premise number
		 * PO box
		 * contract value (move in)
		 * iban
		 */
		var numbersOnly = '[ data-parsley-bpn ], ' +
											'[ data-parsley-mobile_number ], ' +
											'[ data-parsley-telephone_number ], ' +
											'[ data-parsley-verification_code ], ' +
											'[ data-parsley-account_number ], ' +
											'[ data-parsley-account_premise_number ], ' +
											'[ data-parsley-premise_number ], ' +
											'[ data-parsley-pobox ], ' +
											'[ data-parsley-grossfloorarea ], ' +
											'[ data-parsley-iban ], [ data-iban_confirm ], ' +
											'[ data-parsley-notification_number ], ' +
											'[ data-input-numbers ]',

				currencyInput = '[ data-parsley-currency ], ' +
												'[ data-parsley-contract_value ], ' +
												'[ data-parsley-contract-value ]';

		/**
		 * Prevent pasting into the following fields
		 *
		 * IBAN
		 * IBAN confirmation
		 */
		$('[ data-parsley-iban ], ' +
			'[ data-iban_confirm ]').on('paste', function(ev){
			ev.preventDefault();
			ev.stopImmediatePropagation();
		});

		// field length limitations
		$('[ data-parsley-rera_id ]').on( 'keypress.truncate', function () {
			truncateVal($(this),5);
		});
		$('[ data-parsley-rera_id ]').on('paste.truncate', function () {
			queuePasteEvent($(this), 'truncate', 5);
		});

		$('[ data-parsley-verification_code ], ' +
			'[ data-parsley-pobox ], ' +
			'[ data-parsley-grossfloorarea ]').on( 'keypress.truncate', function () {
			truncateVal($(this),6);
		});
		$('[ data-parsley-verification_code ], ' +
			'[ data-parsley-pobox ], ' +
			'[ data-parsley-grossfloorarea ]').on('paste.truncate', function () {
			queuePasteEvent($(this), 'truncate', 6);
		});

		$('[ data-parsley-telephone_number ]').on( 'keypress.truncate', function() {
			truncateVal($(this), 8);
		});
		$('[ data-parsley-telephone_number ]').on('paste.truncate', function () {
			queuePasteEvent($(this), 'truncate',  8);
		});
		$('[ data-parsley-bpn ]').on( 'keypress.truncate', function () {
			truncateVal($(this),8);
		});
		$('[ data-parsley-bpn ]').on('paste.truncate', function () {
			queuePasteEvent($(this), 'truncate', 8);
		});

		$('[ data-parsley-premise_number ], ' +
			'[ data-parsley-notification_number ], ' +
			'[ data-parsley-estimate_number ], ' +
			'[ data-parsley-mobile_number ]').on( 'keypress.truncate', function () {
			truncateVal($(this),10);
		});
		$('[ data-parsley-premise_number ], ' +
			'[ data-parsley-notification_number ], ' +
			'[ data-parsley-estimate_number ], ' +
			'[ data-parsley-mobile_number ]').on('paste.truncate', function () {
			queuePasteEvent($(this), 'truncate', 10);
		});

		$('[ data-parsley-account_number ], ' +
			'[ data-parsley-account_premise_number ]').on( 'keypress.truncate', function () {
			truncateVal($(this),10);
		});
		$('[ data-parsley-account_number ], ' +
			'[ data-parsley-account_premise_number ]').on('paste.truncate', function () {
			queuePasteEvent($(this), 'truncate', 10);
		});

		$('[ data-parsley-emiratesid ]').on( 'keypress.truncate', function () {
			truncateVal($(this),15);
		});
		$('[ data-parsley-emiratesid ]').on('paste.truncate', function () {
			queuePasteEvent($(this), 'truncate', 15);
		});

		$('[ data-parsley-iban ], ' +
			'[ data-iban_confirm ]').on( 'keypress.truncate', function () {
			truncateVal($(this),21);
		});

		$('[ data-parsley-doc_number ]').on( 'keypress.truncate', function () {
			truncateVal($(this),35);
		});
		$('[ data-parsley-doc_number ]').on('paste.truncate', function () {
			queuePasteEvent($(this), 'truncate', 35);
		});

		// generic truncation
		$('[ data-input-truncate ]').on( 'keypress.truncate', function () {
			var truncateTo = parseInt( $(this).data('input-truncate'), 10 );
			truncateVal($(this), truncateTo);
		});
		$('[ data-input-truncate ]').on('paste.truncate', function () {
			var truncateTo = parseInt( $(this).data('input-truncate'), 10 );
			queuePasteEvent($(this), 'truncate', truncateTo);
		});

		// special max partial payment validation
		$('[ data-parsley-max_partial_payment ]').on( 'keyup', function () {
			try{
				if ($(this).val().indexOf('.') && $(this).val().split('.')[1].length > 2) {
					$(this).val( Math.floor(parseFloat($(this).val()) * 100) / 100 );
				}
			} catch(err){}
		});
		$('[ data-parsley-max_partial_payment ]').on('paste.truncate', function () {
			try{
				if ($(this).val().indexOf('.') && $(this).val().split('.')[1].length > 2) {
					$(this).val( Math.floor(parseFloat($(this).val()) * 100) / 100 );
				}
			} catch(err){}
		});


		// number only fields
		$(numbersOnly).on( 'keypress.numbers', constrainNumerals );
		$(numbersOnly).on('paste.numbers', function () {
			queuePasteEvent($(this), 'numbers');
		});

		// currency input types
		$(currencyInput).on( 'keypress.currency', constrainCurrency);
		$(currencyInput).on('paste.currency', function () {
			queuePasteEvent($(this), 'currency');
		});

		// name input types
		$('[ data-parsley-name ]').on( 'keypress.name', constrainName);
		$('[ data-parsley-name ]').on('paste.name', function () {
			queuePasteEvent($(this), 'name');
		});


		// paste event queue
		function queuePasteEvent(el, type, param) {

			pasteQueue[type] = param || true;

			if (!pasteRunner){
				pasteRunner = window.setTimeout(function(){
					var value = el.val();

					// run paste transforms
					if( pasteQueue.numbers ) {
						value = pasteNumerals(value);
					}

					if ( pasteQueue.currency ) {
						value = pasteCurrency(value);
					}

					if ( pasteQueue.name ) {
						value = pasteName(value);
					}

					if ( typeof pasteQueue.truncate === 'number' ) {
						value = truncatePaste(value, param);
					}

					el.val(value);

					resetPasteQueue();
				}, 20);
			}
		}

		// reset queue
		function resetPasteQueue() {
			pasteQueue = [];
			pasteRunner = null;
		}

		// truncation and input rules
		function truncateVal(target, len) {
			if (target.val().length >= len) {
				window.setTimeout(function(){
					target.val(target.val().substring(0,(len)));
				}, 5);
			}
		}
		function truncatePaste(value, len) {
			return value.length >= len ? value.substring(0,(len)) : value;
		}
		function constrainNumerals(ev) {
			var keyCode = ev.which,
					character = String.fromCharCode(keyCode);

			// Allow: special keys and specifically backspace, delete, tab, escape, enter
			if (($.inArray(keyCode, [0, 8, 9, 13, 27, 190]) !== -1 && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+A
				(character === 'a' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+C
				(character === 'c' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+V
				(character === 'v' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+X
				(character === 'x' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: home, end, left, right
				(keyCode >= 35 && keyCode <= 38 && !ev.shiftKey) ||
				 // if allowed character
				 /[0-9]/.test(character)) {
					return;
			}

			// prevent all others
			ev.preventDefault();
		}
		function pasteNumerals(value) {
			return value.replace(/\D/g,'');
		}
		function constrainCurrency(ev) {
			var input = $(ev.target),
					keyCode = ev.which,
					allowDecimal = input.val().indexOf('.') < 0 ? true : false,
					character = String.fromCharCode(keyCode);

			// Allow: backspace, delete, tab, escape, enter
			if (($.inArray(keyCode, [0, 8, 9, 13, 27, 190]) !== -1 && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+A
				(character === 'a' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+C
				(character === 'c' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+V
				(character === 'v' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+X
				(character === 'x' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: home, end, left, right
				(keyCode >= 35 && keyCode <= 38 && !ev.shiftKey) ||
				 // Allowed characters
				(allowDecimal && /[\.]/.test(character) || /[0-9]/.test(character))) {

				// prevent exceeding 2dp
				window.setTimeout(function(){
					if (input.val().indexOf('.') >= 0 && input.val().split('.')[1] && input.val().split('.')[1].length > 2) {
						input.val( Math.floor(parseFloat(input.val()) * 100) / 100 );
					}
				}, 10);

				// allow character
				return;
			}

			// prevent all others
			ev.preventDefault();
		}
		function pasteCurrency(value) {
			var wVal = value.replace(/[^0-9\.]+/g,''),
					sVal, newVal;

			wVal = wVal[0] === '.' ? '0' + wVal : wVal;
			sVal = wVal.split('.');
			newVal = sVal.length > 1 ? sVal[0] + '.' + sVal[1] : sVal[0];

			return newVal;
		}
		function constrainName(ev) {
			var keyCode = ev.which,
					character = String.fromCharCode(keyCode);

			// Allow: backspace, delete, tab, escape, enter
			if (($.inArray(keyCode, [0, 8, 9, 13, 27, 190]) !== -1 && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+A
				(character === 'a' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+C
				(character === 'c' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+V
				(character === 'v' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: Ctrl/Cmd+X
				(character === 'x' && (ev.ctrlKey || ev.metaKey) && !ev.shiftKey) ||
				 // Allow: home, end, left, right
				(keyCode >= 35 && keyCode <= 38 && !ev.shiftKey) ||
				// Allowed characters
				 /[a-zA-Z\s'-]/.test(character)) {
					return;
				}

			// prevent all others
			ev.preventDefault();
		}
		function pasteName(value) {
			return value.replace(/[^a-zA-Z\s'-]+/g,'');
		}

		var FormValidation = function () {

				var formFieldErrorClassname = 'form-field__input--error',
					formFieldWrapperClass = '.form-field__input-wrapper',
					formFieldWrapperErrorClassname = 'form-field__input-wrapper--error',
					formFieldWrapperSuccessClassname = 'form-field__input-wrapper--validated';


				/**
				 * Define parsley custom validators
				 */

				// DEWA Username
				window.Parsley.addValidator( 'username', {

					requirementType: 'string',
					validateString: function ( value ) {
						var patt = new RegExp( /[^a-zA-Z0-9.@]/ );
						return ( value.toString().length >= 6 && value.toString().length <= 75 && !patt.test( value ) );
					}
				} );

				// BPN number
				window.Parsley.addValidator( 'bpn', {

					requirementType: 'integer',
					validateNumber: function ( value ) {
						return value.toString().length === 8;

					}
				} );

				// Account number
				window.Parsley.addValidator( 'estimate_number', {

					requirementType: 'string',
					validateString: function ( value ) {
						return value.toString().length === 9;

					}
				} );

				// Account number
				window.Parsley.addValidator( 'doc_number', {

					requirementType: 'string',
					validateString: function ( value ) {
						var patt = new RegExp( /[^a-zA-Z0-9]/ );
						return value.toString().length === 35 && !patt.test( value );
					}
				} );

				// Account number
				window.Parsley.addValidator( 'account_number', {

					requirementType: 'string',
					validateString: function ( value ) {
						return value.toString().length === 10;

					}
				} );

				// Account number or premise number
				window.Parsley.addValidator( 'account_premise_number', {

					requirementType: 'string',
					validateString: function ( value ) {
						return (value.toString().length >= 9 && value.toString().length <= 10);

					}
				} );

				// Account number
				window.Parsley.addValidator( 'premise_number', {

					requirementType: 'string',
					validateString: function ( value ) {
						return value.toString().length === 9;
					}

				} );

				// Notication number
				window.Parsley.addValidator( 'notification_number', {

					requirementType: 'string',
					validateString: function ( value ) {
						return value.toString().length === 9;

					}
				} );

				// Project generation subject
				window.Parsley.addValidator( 'project_generation_subject', {

					requirementType: 'string',
					validateString: function ( value ) {
						return (value.toString().length > 0 && value.toString().length <= 125);
					}
				} );

				// Contract value
				window.Parsley.addValidator( 'contract_value', {

					requirementType: 'integer',
					validateString: function ( value ) {
						return (value <= 999999999 && value > 0);

					}
				} );

				window.Parsley.addValidator( 'contract-value', {

					requirementType: 'integer',
					validateString: function ( value ) {
						return (value <= 999999999 && value > 0);

					}
				} );

				// PO Box
				window.Parsley.addValidator( 'pobox', {
					requirementType: 'integer',
					validateString: function ( value ) {
						var length = value.toString().length;
						return length <= 6;
					}
				} );

				// PO Box
				window.Parsley.addValidator( 'grossfloorarea', {
					requirementType: 'integer',
					validateString: function ( value ) {
						var length = value.toString().length;
						return length <= 6;
					}
				} );


				// Verification code
				window.Parsley.addValidator( 'verification_code', {

					requirementType: 'string',
					validateString: function ( value ) {

						var patt = new RegExp( /[^0-9]/ );
						return value.toString().length === 6 && !patt.test( value );

					}
				} );

				// Account number
				window.Parsley.addValidator( 'emiratesid', {

					requirementType: 'integer',
					validateNumber: function ( value ) {
						return value.toString().length === 15;

					}
				} );

				// RERA user ID
				window.Parsley.addValidator( 'rera_id', {

					requirementType: 'string',
					validateString: function ( value ) {

						return value.toString().length > 5;

					}
				} );

				// IBAN
				window.Parsley.addValidator( 'iban', {
					requirementType: 'string',
					validateString: function ( value ) {
						var prefix = '1014',
								ibanTrans;

						if (value.toString().length === 21) {
							prefix += value.slice(0, 2);
							ibanTrans = value.substr(2) + prefix;

							return modulo(ibanTrans, 97) === '1';
						}

						return false;
					}
				} );

				// Year
				window.Parsley.addValidator( 'year', {
					requirementType: 'integer',
					validateNumber: function ( value ) {
						var d = new Date();
						return value.toString().length === 4 && value <= d.getFullYear();
					}
				} );

				// Year
				window.Parsley.addValidator( 'max_partial_payment', {
					requirementType: 'number',
					validateNumber: function ( value, requirement ) {
						return ( ( value <= 200000 + requirement ) && value >= 0 );
					}
				} );

				// password
				window.Parsley.addValidator( 'password', {

					requirementType: 'string',
					validateString: function ( value, requirement ) {

						var matched = true,
							usernameField = $( requirement )[ 0 ];

						if ( usernameField !== undefined && ( usernameField.value === value ) ) {

							matched = false;
						} else {

							matched = value.match( value.match( ( /^(?=.*\d)(?=.*[\D])[0-9\D]{8,}$/ ) ) ) !== null;
						}

						return matched;
					}
				} );

				//telephone number
				window.Parsley.addValidator( 'telephone_number', {
					requirementType: 'string',
					validateString: function ( value ) {
						return value.match( /^(?:2|3|4|6|7|9)\d{7}$/ ) !== null;
					}
				} );

				//telephone number
				window.Parsley.addValidator( 'mobile_number', {
					requirementType: 'string',
					validateString: function ( value ) {
						return ((value.match(/^(?:50|51|52|53|54|55|56|57|58|59|52|54|55|56|050|051|052|053|054|055|056|057|058|059|052|054|055|056)\d{7}$/) !== null) && !(/\b(1|0|5|9)\1+\b/).test(value.substring(2)));
					}
				} );

				// currency value
				window.Parsley.addValidator( 'currency', {
					requirementType: 'string',
					validateString: function ( value ) {
						return value.match( /^\d*(\.\d{1,3})?$/ ) !== null;
					}
				} );

				// name value
				window.Parsley.addValidator( 'name', {
					requirementType: 'string',
					validateString: function ( value ) {
						return value.match( /^[a-zA-Z\s'-]*$/ ) !== null;
					}
				} );

				// min and max bill total
				window.Parsley.addValidator( 'billtotalmax', {
					requirementType: 'string',
					validateString: function ( value, max ) {
						var valFloat = parseFloat(value);

						return valFloat <= max;
					}
				} );
				window.Parsley.addValidator( 'billtotalmin', {
					requirementType: 'string',
					validateString: function ( value, min ) {
						var valFloat = parseFloat(value);

						return valFloat > min;
					}
				} );

				/**
				 * Listen to parsley events
				 */


				window.Parsley.on( 'form:validate', function (form) {
					if (!form.isValid()) {
						for (var n = 0; n < form.fields.length; n++) {
							if (form.fields[n].validationResult !== true) {
								if(window.navigator.userAgent.match(/iphone|ipad/i)) {
									window.setTimeout(function() {
										$("html,body").animate({
											scrollTop: $(form.fields[n].$element[0]).offset().top
										});
									}, 0);
								}
								break;
							}
						}
					}
				});


				window.Parsley.on( 'field:success', function () {

					var type = this.$element.attr( 'type' ),
					nosymbol = this.$element.attr('required') === undefined && this.$element.val().length === 0;

					this.$element.attr( 'aria-invalid', false );

					if( nosymbol ) {

						this.$element.removeClass( formFieldErrorClassname );
						this.$element.parents( formFieldWrapperClass ).removeClass( formFieldWrapperErrorClassname );
					}

					else {

						if ( type !== 'file' ) {

							this.$element.removeClass( formFieldErrorClassname );
							this.$element.parents( formFieldWrapperClass ).removeClass( formFieldWrapperErrorClassname ).addClass( formFieldWrapperSuccessClassname );
						}

					}

				} );

				window.Parsley.on( 'field:error', function () {

					var type = this.$element.attr( 'type' );

					this.$element.attr( 'aria-invalid', true );

					if ( type !== 'file' && type !== 'checkbox' && type !== 'radio' ) {

						this.$element.addClass( formFieldErrorClassname );
						this.$element.parents( formFieldWrapperClass ).removeClass( formFieldWrapperSuccessClassname ).addClass( formFieldWrapperErrorClassname );

					}

				} );

			},
			_singleton;

		FormValidation.prototype.apply = function ( $form ) {

			// on parsley triggers
			$form.find( 'input[type=text], input[type=number], input[type=email], input[type=tel]' ).not( '[data-el=datepicker]' ).attr( 'data-parsley-trigger', 'focusout' );
			$form.find( 'select' ).attr( 'data-parsley-trigger', 'change' );

			// global parsley options
			$form.parsley( {

				excluded: 'input.form-field__input--readonly, input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden'
			} );

			// accessibility fix for form submission on pressing enter (not happening on the forms with multiple buttons)
			$form.find( 'input[type=text], input[type=number], input[type=email], input[type=tel], select' ).on( 'keydown.submit', function ( event ) {

				var keycode = ( event.keyCode ? event.keyCode : ( event.which ? event.which : event.charCode ) );

				if ( keycode === 13 ) {

					var $submit = $form.find( '[type=submit]' );

					if ( $submit[ 0 ] !== undefined ) {

						$submit.last().trigger( 'click' );
						return false;
					}
				}
			} );

			// on special validation rules for Emirates ID
			$form.find( '#form-field-user_id_type' ).on('change.emiratesid', function(){
				var idField = $( '#form-field-user_id_no' ),
						select = $(this);

				if (select.val() === 'ED') {
					truncateVal(idField, 15);

					idField.attr( 'data-parsley-emiratesid', true );
					idField.on( 'keypress.eid', function () {
						truncateVal(idField, 15);
					});
					idField.on('paste.eid', function () {
						queuePasteEvent(idField, 'truncate', 15);
					});
				} else {

					idField.removeAttr( 'data-parsley-emiratesid' );
					idField.off( '.eid' );
				}

				window.setTimeout(function(){
					if (idField.parsley().validationResult === true || typeof idField.parsley().validationResult === 'object' && idField.parsley().validationResult.length){
						idField.parsley().validate();
					}
				}, 10);

			});

		};

		_singleton = new FormValidation();

		return _singleton;
	} );

